import { I18n as I } from 'react-redux-i18n';
import { PartyTypes, AuctionStatuses, isArray, isFunc } from 'vdlib';

import {
  AlertOutlined,
  CarOutlined,
  CheckOutlined,
  CloseOutlined,
  DislikeOutlined,
  EditOutlined,
  FileTextOutlined,
  FolderAddOutlined,
  LikeOutlined,
  RedoOutlined,
} from '@ant-design/icons';

export const PortletActionTypes = {
  StartAuction: 'StartAuction', //onClick: (auctionComponent) => auctionComponent.setState({ showDatePickerModal: true })
  EditAuction: 'EditAuction', //onClick: (auctionComponent) => auctionComponent.setState({ showDatePickerModal: true })
  CreateInFolderAuction: 'CreateInFolderAuction',
  CommentAuction: 'CommentAuction', //onClick: (auctionComponent) => auctionComponent.setState({ showDatePickerModal: true })
  AcceptAuction: 'AcceptAuction', //onClick:  (auctionComponent) => auctionComponent.props.acceptAuction(auctionComponent.props.auction.ID, auctionComponent.props.auction.GarageID)
  RejectAuction: 'RejectAuction', //onClick:  (auctionComponent) => auctionComponent.props.rejectAuction(auctionComponent.props.auction.ID)
  DispatchAuction: 'DispatchAuction', //onClick:  (auctionComponent) => auctionComponent.props.dispatchAuction(auctionComponent.props.auction.ID)
  DispatchAuctionProblem: 'DispatchAuctionProblem', //onClick:  (auctionComponent) => auctionComponent.props.dispatchAuction(auctionComponent.props.auction.ID)
  CancelAuction: 'CancelAuction', //
};

// enable cancelation for all statuses on operator
const populateActions = () => {
  let gpa = {
    [`${PartyTypes.Operator}_${AuctionStatuses.Pending}`]: [
      {
        className: 'green',
        icon: <CheckOutlined />,
        title: I.t('APPROVAL'),
        actionType: PortletActionTypes.StartAuction,
      },
      {
        className: '#1d3557',
        icon: <EditOutlined />,
        title: I.t('EDIT'),
        actionType: PortletActionTypes.EditAuction,
      },
      {
        className: '#1d3557',
        icon: <FileTextOutlined />,
        title: I.t('COMMENTS'),
        actionType: PortletActionTypes.CommentAuction,
      },
      {
        className: '#d62828',
        icon: <CloseOutlined />,
        title: I.t('CANCELLATION'),
        actionType: PortletActionTypes.CancelAuction,
      },
    ],
    [`${PartyTypes.Operator}_${AuctionStatuses.Active}`]: [
      {
        className: '#1d3557',
        icon: <FileTextOutlined />,
        title: I.t('COMMENTS'),
        actionType: PortletActionTypes.CommentAuction,
      },
      {
        className: '#1d3557',
        icon: <EditOutlined />,
        title: I.t('EDIT'),
        actionType: PortletActionTypes.EditAuction,
      },
      {
        className: '#d62828',
        icon: <CloseOutlined />,
        title: I.t('CANCELLATION'),
        actionType: PortletActionTypes.CancelAuction,
      },
    ],
    [`${PartyTypes.Operator}_${AuctionStatuses.ForSelection}`]: [
      {
        className: '#1d3557',
        icon: <FileTextOutlined />,
        title: I.t('COMMENTS'),
        actionType: PortletActionTypes.CommentAuction,
      },
      {
        className: '#1d3557',
        icon: <EditOutlined />,
        title: I.t('EDIT'),
        actionType: PortletActionTypes.EditAuction,
      },
      {
        className: 'green',
        icon: <RedoOutlined />,
        title: I.t('RESTART'),
        actionType: PortletActionTypes.StartAuction,
      },
      {
        className: '#d62828',
        icon: <CloseOutlined />,
        title: I.t('CANCELLATION'),
        actionType: PortletActionTypes.CancelAuction,
      },
    ],

    [`${PartyTypes.Admin_Insurance}_${AuctionStatuses.Pending}`]: [
      {
        className: 'green',
        icon: <CheckOutlined />,
        title: I.t('APPROVAL'),
        actionType: PortletActionTypes.StartAuction,
      },
      {
        className: '#1d3557',
        icon: <EditOutlined />,
        title: I.t('EDIT'),
        actionType: PortletActionTypes.EditAuction,
      },
      {
        className: '#1d3557',
        icon: <FileTextOutlined />,
        title: I.t('COMMENTS'),
        actionType: PortletActionTypes.CommentAuction,
      },
      {
        className: '#d62828',
        icon: <CloseOutlined />,
        title: I.t('CANCELLATION'),
        actionType: PortletActionTypes.CancelAuction,
      },
    ],
    [`${PartyTypes.Admin_Insurance}_${AuctionStatuses.Active}`]: [
      {
        className: '#1d3557',
        icon: <FileTextOutlined />,
        title: I.t('COMMENTS'),
        actionType: PortletActionTypes.CommentAuction,
      },
      {
        className: '#1d3557',
        icon: <EditOutlined />,
        title: I.t('EDIT'),
        actionType: PortletActionTypes.EditAuction,
      },
      {
        className: '#d62828',
        icon: <CloseOutlined />,
        title: I.t('CANCELLATION'),
        actionType: PortletActionTypes.CancelAuction,
      },
    ],
    [`${PartyTypes.Admin_Insurance}_${AuctionStatuses.ForSelection}`]: [
      {
        className: '#1d3557',
        icon: <FileTextOutlined />,
        title: I.t('COMMENTS'),
        actionType: PortletActionTypes.CommentAuction,
      },
      {
        className: '#1d3557',
        icon: <EditOutlined />,
        title: I.t('EDIT'),
        actionType: PortletActionTypes.EditAuction,
      },
      {
        className: 'green',
        icon: <RedoOutlined />,
        title: I.t('RESTART'),
        actionType: PortletActionTypes.StartAuction,
      },
      {
        className: '#d62828',
        icon: <CloseOutlined />,
        title: I.t('CANCELLATION'),
        actionType: PortletActionTypes.CancelAuction,
      },
    ],

    [`${PartyTypes.Merchant}_${AuctionStatuses.ForAcceptance}`]: [
      {
        className: 'green',
        icon: <LikeOutlined />,
        title: I.t('ACCEPTANCE'),
        actionType: PortletActionTypes.AcceptAuction,
      },
      {
        className: '#d62828',
        icon: <DislikeOutlined />,
        title: I.t('REJECTION'),
        actionType: PortletActionTypes.RejectAuction,
      },
    ],
    [`${PartyTypes.Merchant}_${AuctionStatuses.ForDispatch}`]: [
      {
        className: 'blue',
        icon: <CarOutlined />,
        title: I.t('DISPATCH'),
        actionType: PortletActionTypes.DispatchAuction,
      },
      {
        className: 'red',
        icon: <AlertOutlined />,
        title: I.t('DISPATCH_PROBLEM'),
        actionType: PortletActionTypes.DispatchAuctionProblem,
      },
    ],
    [`${PartyTypes.Merchant}_${AuctionStatuses.DispatchProblem}`]: [
      {
        className: 'blue',
        icon: <CarOutlined />,
        title: I.t('DISPATCH'),
        actionType: PortletActionTypes.DispatchAuction,
      },
      {
        className: 'red',
        icon: <AlertOutlined />,
        title: I.t('DISPATCH_PROBLEM'),
        actionType: PortletActionTypes.DispatchAuctionProblem,
      },
    ],
    [`${PartyTypes.Insurance}_*`]: [
      {
        className: '#1d3557',
        icon: <FolderAddOutlined />,
        title: I.t('NEW_AUCTION_IN_FOLDER'),
        actionType: PortletActionTypes.CreateInFolderAuction,
      },
    ],
    [`${PartyTypes.Insurance}_${AuctionStatuses.Active}`]: [
      {
        className: '#d62828',
        icon: <CloseOutlined />,
        title: I.t('CANCELLATION'),
        actionType: PortletActionTypes.CancelAuction,
      },
    ],
    [`${PartyTypes.Insurance}_${AuctionStatuses.ForSelection}`]: [
      {
        className: '#d62828',
        icon: <CloseOutlined />,
        title: I.t('CANCELLATION'),
        actionType: PortletActionTypes.CancelAuction,
      },
    ],
  };

  return gpa;
};

const getPortletActions = (
  partyTypeDescription,
  auctionStatusDescription,
  callbacksObj,
  componentToBind
) => {
  const allActions = populateActions();
  const rawActions = [
    ...(allActions[`${partyTypeDescription}_${auctionStatusDescription}`] ||
      []),
    ...(allActions[`${partyTypeDescription}_*`] || []),
  ];

  return rawActions.map(a =>
    Object.assign({}, a, {
      onClick: isFunc(callbacksObj[a.actionType])
        ? callbacksObj[a.actionType].bind(componentToBind) // (isFunc(a.actionType.bind) ? a.actionType.bind(componentToBind) : a.actionType)
        : e => console.warn('no action wi#d62828 up on button', e.target),
    })
  );
};

export default getPortletActions;
